(function ($, Drupal) {
  /**
   * Helper to match all card heights in a container.
   *
   * @param {Object} context
   * JS context.
   */
  function matchAllHeightContainer(context) {
    const container = $(".row-matcheight", context);
    const containerByRow = $(".row-matcheight-byrow", context);

    const el = [
      ".card-title",
      ".card-text",
      ".card-footer",
      ".card-header",
      ".card-img-top",
      ".card-category",
      ".card-body",
      ".card-img",
      ".matchBlock",
      ".cta_icon-item",
    ];

    /**
     * Make them all equal heights.
     */

    $.each(container, function (i, block) {
      const r = Math.random().toString(36).substr(2, 5) + i;
      $(block).addClass(`item-${r}`);

      $.each(el, function (index, item) {
        const section = $(block).find(item);
        $(section).matchHeight({
          byRow: false,
          property: "height",
        });
      });
    });

    $.each(containerByRow, function (i, block) {
      const r = Math.random().toString(36).substr(2, 5) + i;
      $(block).addClass(`item-${r}`);

      $.each(el, function (index, item) {
        const section = $(block).find(item);
        $(section).matchHeight({
          byRow: true,
          property: "height",
        });
      });
    });
  }

  /**
   * Core or Misc.
   */
  Drupal.behaviors.wncMatchHeight = {
    attach: function attach(context) {
      matchAllHeightContainer(context);

      const others = [
        // '.card',
      ];

      $.each(others, function (index, item) {
        $(item).matchHeight();
      });
    },
  };

  /**
   * For images with b-lazy load, rebind matchHeight when real images are loaded
   */
  Drupal.behaviors.wncLazyMatch = {
    attach: function attach(context) {
      $(once("lazy-loaded", ".card img.b-lazy")).on("load", function () {
        matchAllHeightContainer(context);
      });
    },
  };
})(jQuery, Drupal);
